export function NotFound() {
  return <div>Not found</div>;
}
